import React, { Component } from 'react';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

const StyledP = styled.p`
  img{
    max-width:80%;
    max-height:300px;
    display:block;
    margin: 10px auto;
  }
`;


class RichTextViewer extends Component {
  render() {
    if (!this.props.content) return null;
    return (
      <StyledP
        style={this.props.style}
        className={`rich-text-viewer break-lines ${this.props.className}`}
        dangerouslySetInnerHTML={{
          __html:
        sanitizeHtml(this.props.content, {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'u']),
          allowedAttributes: {
            a: ['href', 'name', 'target'],
            img: ['src'],
          },
        }),
        }}
      />
    );
  }
}

export default RichTextViewer;
